import { PrimaryButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useDownloadFinancialAccountStatementPresenter } from './useDownloadFinancialAccountStatementPresenter'

export interface IDownloadFinancialAccountStatementPresenterProps {
  financialAccountId: number
  /** Statement period in `"YYYY-MM"` format. */
  datePeriod: Nullable<string>
  onSuccess: () => void
}

export const DownloadFinancialAccountStatementPresenter = ({
  financialAccountId,
  datePeriod,
  onSuccess,
}: IDownloadFinancialAccountStatementPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    commands: { downloadStatement },
    states: { isDownloading, isDownloadDisabled },
  } = useDownloadFinancialAccountStatementPresenter({
    financialAccountId,
    datePeriod,
    onSuccess,
  })

  return (
    <PrimaryButton
      type='button'
      onClick={() => downloadStatement()}
      isLoading={isDownloading}
      disabled={isDownloadDisabled}
    >
      {intl.formatMessage(messages.downloadButtonText)}
    </PrimaryButton>
  )
}

DownloadFinancialAccountStatementPresenter.displayName =
  'DownloadFinancialAccountStatementPresenter'
